import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

export function NewPOAPowersIntro() {
  const navigate = useNavigate();
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../powers-intro');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../banking');
  }, [ navigate ]);
  
  return (
    <div className="new-poa-powers-intro screen-container screen">
      <ScreenHeader
        title="Assigning Powers"
        description="Now you'll specify exactly what your agent can and cannot do with your finances"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Powers Will You Grant?</h3>
        <p>
          A Power of Attorney can be as broad or as limited as you choose. You can grant 
          your agent authority over specific areas of your finances while keeping other 
          areas under your control.
        </p>

        <h3>Areas We'll Cover</h3>
        <ul className="powers-list">
          <li><strong>Real Estate Transactions:</strong> Buying, selling, and managing property</li>
          <li><strong>Tangible Personal Property:</strong> Managing your personal belongings and assets</li>
          <li><strong>Securities Transactions:</strong> Managing stocks, bonds, and other investments</li>
          <li><strong>Banking Transactions:</strong> Accessing and managing bank accounts</li>
          <li><strong>Business Operations:</strong> Running any businesses you own</li>
          <li><strong>Digital Assets:</strong> Managing online accounts and digital property</li>
          <li><strong>Insurance & Annuities:</strong> Managing insurance policies and annuity contracts</li>
          <li><strong>Estate & Trust Transactions:</strong> Managing estate and trust matters</li>
          <li><strong>Legal Actions:</strong> Taking legal action on your behalf</li>
          <li><strong>Personal & Family Care:</strong> Making decisions about your personal care</li>
          <li><strong>Pet Care:</strong> Caring for your pets and animals</li>
          <li><strong>Government Benefits:</strong> Managing Social Security and other benefits</li>
          <li><strong>Retirement Plans:</strong> Managing retirement accounts and pensions</li>
          <li><strong>Tax Matters:</strong> Handling tax returns and tax-related issues</li>
        </ul>

        <h3>How This Works</h3>
        <p>
          For each area, we'll explain what the power means and give you options to:
        </p>
        <ul className="options-list">
          <li>Grant full authority in that area</li>
          <li>Grant limited authority with specific restrictions</li>
          <li>Not grant any authority in that area</li>
        </ul>

        <div className="important-note">
          <h4>Remember:</h4>
          <p>
            You can always change these powers later by creating a new Power of Attorney document. 
            The new document will automatically revoke the old one.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Start Assigning Powers"
      />
    </div>
  );
}
